/* eslint-disable */
/**
 * Product
 *
 * Minimal conversion from jQuery to native JavaScript - preserves original behavior
 * Direct copy of apps/rockwell-aem-commerce/components/commerce/product/clientlib/js/product.js
 * Only price and cart are removed from the source.
 */

import { getBreakpointMediaQuery } from 'js/constants.js';

let isPrint = false;

class Product {
    constructor() {
        // [LEGACY BREAKPOINT: max-width 48em -> getBreakpointMediaQuery('down', 'small')]
        this.matchMobile = getBreakpointMediaQuery('down', 'small');
        this.elements = {
            thumbnailsButton: document.querySelectorAll(".thumbnail.thumbnail__root__product")
        };

        this.addEventListeners();
        this.handleMatchMobileChange();
        this.initThumbnailHandlers();
    }

    initThumbnailHandlers() {
        this.elements.thumbnailsButton.forEach((thumbnail) => {
            thumbnail.addEventListener("click", (e) => {
                const clickedThumbnail = e.currentTarget;
                const image = clickedThumbnail.querySelector('img');
                const iframe = clickedThumbnail.querySelector('iframe');
                const activeImg = document.querySelector('.thumbnailList__root [active="true"]');

                // Remove active state from previous thumbnail
                if (activeImg) {
                    activeImg.setAttribute('active', 'false');
                    activeImg.classList.remove('thumbnail__rootSelected');
                }

                // Set new active state
                clickedThumbnail.setAttribute('active', 'true');
                clickedThumbnail.classList.add('thumbnail__rootSelected');

                if (image) {
                    console.log("image : " + image.getAttribute('src'));
                    const src = image.getAttribute('src');
                    this.thumbnailsButtonHandler(src, "image");
                } else if (iframe) {
                    const src = iframe.getAttribute('src');
                    console.log("video: " + iframe.getAttribute('src'));
                    this.thumbnailsButtonHandler(src, "video");
                } else {
                    // empty image and video
                    const containerGallery = document.querySelector(".carousel__imageContainer");
                    const video = containerGallery?.querySelector('iframe');
                    const image = containerGallery?.querySelector('img');

                    if (video) {
                        video.style.visibility = 'hidden';
                    }
                    if (image) {
                        image.style.visibility = 'hidden';
                    }
                }
            });
        });
    }

    handleMatchMobileChange() {
        const specTable = document.querySelector('#specTable');
        const specTableHeader = document.querySelector('.productTable__tableHeader');

        const isMobile = this.matchMobile.matches && !isPrint;

        // Expand all sections on desktop
        if (specTable) {
            specTable.open = !isMobile;
            specTable.tabIndex = isMobile ? 0 : -1;
            specTable.style.pointerEvents = isMobile ? '' : 'none';

            if (specTableHeader) {
                specTableHeader.innerHTML = isMobile ? 'Specifications' : 'Technical Specifications';
            }
        }
    }

    addEventListeners() {
        // Ensure sections remain expanded on desktop
        this.matchMobile.addEventListener('change', () => this.handleMatchMobileChange());

        window.addEventListener('beforeprint', (event) => {
            isPrint = true;
            const tableHeader = document.querySelector('.productTable__tableHeader');
            if (tableHeader) {
                tableHeader.innerHTML = 'Technical Specifications';
            }

            const bodyZoomStyle = document.createElement('style');
            bodyZoomStyle.innerHTML = `
                @media print {
                    body {
                        zoom: 65%;
                    }

                    .footer,
                    ._hj_feedback_containers {
                        display: none;
                    }
                }
            `;
            document.head.appendChild(bodyZoomStyle);
        });

        window.addEventListener('afterprint', (event) => {
            isPrint = false;
        });
    }

    thumbnailsButtonHandler(src, type) {
        const containerGallery = document.querySelector(".carousel__imageContainer");

        if (!containerGallery) return;

        const video = containerGallery.querySelector('iframe');
        const image = containerGallery.querySelector('img');

        if (type === 'image') {
            // Hide video, show image
            if (video) {
                video.style.visibility = 'hidden';
            }
            if (image) {
                image.setAttribute('src', src);
                image.style.visibility = 'visible';
            }
        } else if (type === 'video') {
            // Hide image, show video
            if (image) {
                image.style.visibility = 'hidden';
            }
            if (video) {
                video.setAttribute('src', src);
                video.style.visibility = 'visible';
            }
        }
    }
}

// Initialize product functionality
const productElement = document.querySelector(".product");
if (productElement) {
    new Product();

    const productDetail = document.querySelector(".product .productFullDetail__root");
    const sku = productDetail?.dataset.sku;
    const productName = productDetail?.dataset.productName;

    if (productName !== undefined && sku) {
        // Appending to Breadcrumb
        const lastBreadcrumb = document.querySelector('.breadcrumb__item:last-child');
        if (lastBreadcrumb) {
            const clonedBreadcrumb = lastBreadcrumb.cloneNode(true);
            const linkText = clonedBreadcrumb.querySelector('.breadcrumb__link_text');
            const link = clonedBreadcrumb.querySelector('.breadcrumb__link');

            if (linkText) linkText.textContent = sku;
            if (link) {
                // Remove the link wrapper but keep the content
                link.outerHTML = link.innerHTML;
            }

            lastBreadcrumb.parentNode.appendChild(clonedBreadcrumb);
        }

        // Email page functionality
        const emailButton = document.querySelector('#email-page');
        if (emailButton) {
            emailButton.addEventListener('click', () => {
                const canonicalLink = document.querySelector('link[rel="canonical"]');
                const uri = canonicalLink?.getAttribute('href') || '';
                const catalogNumber = 'Catalog #: ' + sku;
                const brand = 'Rockwell Automation';
                const body = productName + ' from ' + brand + '\n' + catalogNumber + '\n' + uri + '\n';

                window.location.href = 'mailto:?subject=' + encodeURIComponent(brand + ' ' + productName) + '&body=' + encodeURIComponent(body);
            });
        }

        // Literature search configuration
        const searchConfig = document.querySelector(".search__configuration");
        const locale = searchConfig?.getAttribute("data-search-locale") || 'en-US';
        const searchEndpoint = searchConfig?.getAttribute('data-search-base-url') || 'https://www.rockwellautomation.com/search';
        const endpoint = `${searchEndpoint}/ra-${locale};keyword=${sku};activeTab=Literature;`;

        const literatureResult = document.querySelector('#literature-result');
        if (literatureResult) {
            literatureResult.setAttribute("href", endpoint);
        }

        // Reformat dates (to display full text name of month)
        const dateObject = document.querySelector('.date-value');
        if (dateObject) {
            const dateString = dateObject.textContent;
            let dateDate = null;

            if (dateString.match(/^\d{2}\/\d{2}\/\d{4}$/)) { // old date format
                dateDate = new Date(
                    dateString.substring(6, 10),
                    dateString.substring(3, 5) - 1,
                    dateString.substring(0, 2)
                );
            } else if (dateString.match(/^\d{4}-\d{2}-\d{2}T.+Z$/)) { // new date format
                dateDate = new Date(
                    dateString.substring(0, 4),
                    dateString.substring(5, 7) - 1,
                    dateString.substring(8, 10)
                );
            }

            if (dateDate) {
                // Only supporting en-US locale since content is English only (regardless of page locale)
                const formattedDate = dateDate.toLocaleString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                });
                dateObject.textContent = formattedDate;
            }
        }
    }
}
